import DoneIcon from '../icons/DoneIcon';
import PopupCommonExternal, { PopupCommonExternalProps } from './PopupCommonExternal';

export default function PopupSuccess({ ...props }: PopupCommonExternalProps) {
	return <PopupCommonExternal {...props} icon={<DoneIcon color='primary' className='text-6xl' />} />;
}
